import { render } from "./HumanRights.vue?vue&type=template&id=93357d7e&scoped=true"
import script from "./HumanRights.vue?vue&type=script&lang=js"
export * from "./HumanRights.vue?vue&type=script&lang=js"

import "./HumanRights.vue?vue&type=style&index=0&id=93357d7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93357d7e"]])

export default __exports__